import routerOptions0 from "E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}